export default "__VITE_ASSET__GX92Hv3D__"